import * as MutationsType from "./mutationsType";

export default {
  [MutationsType.SET_QUOTAS](state, payload) {
    state.quotas = payload;
  },
};
